import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-609f6f4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = { style: {"font-size":"13px","display":"block","margin-left":"20px","margin-right":"33px","color":"rgba(142, 98, 122)"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "headeruser",
  style: {"font-size":"16px","display":"block","margin-left":"20px","margin-right":"33px"}
}, "欢迎您！ 知了平台管理员", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Expand = _resolveComponent("Expand")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_icon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dianji())),
        size: 20
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_Expand, null, null, 512), [
            [_vShow, _ctx.isShow]
          ]),
          _withDirectives(_createVNode(_component_Fold, null, null, 512), [
            [_vShow, !_ctx.isShow]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_breadcrumb, { separator: "/" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routesmatch, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: index }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_image, {
          src: _ctx.touxiang,
          style: {"width":"40px","height":"40px","border-radius":"50%","border":"2px solid #a5b79f"}
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, "账号：" + _toDisplayString(_ctx.zhanghao), 1),
        _hoisted_4
      ]),
      _createVNode(_component_el_button, { link: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
            default: _withCtx(() => [
              _createVNode(_component_SwitchButton)
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tuichu()))
          }, "退出")
        ]),
        _: 1
      })
    ])
  ], 64))
}